"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Input = _interopRequireDefault(require("./Input"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var PhoneNumberInput = function PhoneNumberInput(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, ["value", "onChange"]);

  var splice = function splice(value, start, deleteCount, newSubStr) {
    return value.slice(0, start) + newSubStr + value.slice(start + Math.abs(deleteCount));
  };

  var handleChange = function handleChange(event) {
    var value = event.target.value;

    if (value.includes("(") && !value.includes(")")) {
      value = value.substring(0, value.length - 1);
    }

    value = value.replace("(", "");
    value = value.replace(")", "");
    value = value.replace("-", "");
    value = value.replace(/\s/g, "");

    if (value.length <= 10 && !isNaN(value)) {
      onChange(value);
    }
  };

  var convertValue = function convertValue(value) {
    if (value.length > 2) {
      value = splice(value, 0, 0, "(");
      value = splice(value, 4, 0, ")");
    }

    if (value.length > 5) {
      value = splice(value, 5, 0, " ");
    }

    if (value.length > 9) {
      value = splice(value, 9, 0, " - ");
    }

    return value;
  };

  return _react["default"].createElement(_Input["default"], _extends({
    value: convertValue(value),
    onChange: handleChange
  }, rest));
};

PhoneNumberInput.defaultProps = {};
PhoneNumberInput.propTypes = {
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  onChange: _propTypes["default"].func.isRequired
};
var _default = PhoneNumberInput;
exports["default"] = _default;